document.addEventListener("DOMContentLoaded", function () {
  const box = document.querySelector(".rentalinquirybox");
  if (!box) return;

  function updateStickyInquirybox() {
    const viewportHeight = window.innerHeight;
    const boxHeight = box.offsetHeight;
    if (boxHeight > viewportHeight - 85) {
      box.classList.add("rentalinquirybox--static");
    } else {
      box.classList.remove("rentalinquirybox--static");
    }
  }

  function handleStickyCheck() {
    if (window.innerWidth > 1024) {
      // 64rem = 1024px
      updateStickyInquirybox();
    } else {
      box.classList.remove("rentalinquirybox--static");
    }
  }

  handleStickyCheck();

  window.addEventListener("resize", handleStickyCheck);

  if ("ResizeObserver" in window) {
    const ro = new ResizeObserver(() => {
      handleStickyCheck();
    });
    ro.observe(box);
  }
});
